module.exports = __webpack_public_path__ + "static/img/invest-earth.9876887.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/invest-earth.png
// module id = emWn
// module chunks = 0